module.exports = __webpack_public_path__ + "assets/img/solution8.64b5d6e6.png";